module.exports = __webpack_public_path__ + "media/images/application/template/logo-modular-d29c6a891ce2c2db411a9335b040c48b.svg";